export default "__VITE_ASSET__DwNfow1P__"